import React, { ReactNode } from 'react';

export function messageArrayToHelperText(messages: (string | null)[]): ReactNode {
    let notEmptyMessages = messages.filter(m => m !== undefined && m !== null && m.length > 0) as string[];
    notEmptyMessages = notEmptyMessages.distinct(m => m);

    if (notEmptyMessages.length === 0) {
        return null;
    }

    return (
        <React.Fragment>
            {notEmptyMessages.map(m => <React.Fragment key={m}>{m}<br /></React.Fragment>)}
        </React.Fragment>
    );
}